<template>
  <div>
    <b-container>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(next)" autocomplete="off">
          <b-card>
            <template #header>
              <h6 class="mb-0">Cuestionario médico de asegurabilidad</h6>
            </template>

            <p class="text-muted small mb-3">
              Responda Sí o No para cada persona a asegurar, según corresponda.
            </p>

            <div
              v-for="(persona, indexPersona) in personasConDatos"
              :key="'pers-' + indexPersona"
              class="mb-3"
            >
              <b-card no-body class="cuestionario-persona-card">
                <b-card-header
                  role="button"
                  class="d-flex align-items-center justify-content-between py-2 cuestionario-persona-header"
                  @click="togglePersona(indexPersona)"
                >
                  <span class="font-weight-bold mb-0 cuestionario-persona-nombre">
                    {{ persona.name || "Persona " + (indexPersona + 1) }}
                  </span>
                  <span class="d-flex align-items-center">
                    <b-button
                      variant="link"
                      size="sm"
                      class="p-0 mr-2 text-secondary d-inline-flex align-items-center"
                      :title="'Marcar todo No'"
                      @click.stop="marcarTodoNo(persona)"
                    >
                      <b-icon icon="dash-circle" font-scale="1.2" />
                    </b-button>
                    <b-button
                      variant="link"
                      size="sm"
                      class="p-0 mr-2 text-secondary d-inline-flex align-items-center"
                      :title="'Limpiar secciones'"
                      @click.stop="limpiarSeccionesPersona(persona)"
                    >
                      <b-icon icon="eraser" font-scale="1.2" />
                    </b-button>
                    <span class="cuestionario-contadas mr-3">
                      {{ contestadasCount(persona) }} de {{ preguntasCount(persona) }}
                    </span>
                    <b-icon
                      :icon="personasAbiertas[indexPersona] ? 'chevron-up' : 'chevron-down'"
                      font-scale="1.1"
                      class="cuestionario-persona-chevron"
                    />
                  </span>
                </b-card-header>
                <b-collapse :visible="personasAbiertas[indexPersona]" :id="'collapse-persona-' + indexPersona">
                  <b-card-body class="pt-2 pb-3">
                    <b-form-group
                      v-for="(pregunta, indexPregunta) in PREGUNTAS_CUESTIONARIO_MEDICO"
                      v-show="pregunta.code < 22 || persona.sex === 'F'"
                      :key="'p-' + indexPersona + '-' + indexPregunta"
                      class="cuestionario-pregunta"
                    >
                      <b-row align-v="center" no-gutters class="cuestionario-row">
                        <b-col class="pr-2">
                          <label class="col-form-label font-weight-normal mb-0 text-break">
                            {{ pregunta.code + ". " + pregunta.label }}                             
                          </label>
                        </b-col>

                        
                        <b-col cols="auto" class="cuestionario-sino-wrap">
                          <!-- P22 mujeres: fecha esperada alumbramiento -->
                          <template v-if="pregunta.code === 23 && persona.sex === 'F'">
                            <DateComponent        
                              :form="persona"
                              label="dd/mm/aaaa"
                              name="fechaPregunta22"
                              class="d-inline-block"
                            />
                          </template>
                          <!-- P24 mujeres: 4 campos numéricos -->
                          <template v-else-if="pregunta.code === 24 && persona.sex === 'F'">
                            <b-row no-gutters class="cuestionario-p24-filas">
                              <b-col cols="6" md="3" class="pr-1 mb-1">                                
                                <TextComponent 
                                  :form="persona.detallePregunta24" 
                                  name="nEmbarazos" 
                                  label="N° Embarazos"
                                  type="number"        
                                  step="1"                                   
                                  rules="required|min_value:0|max_value:20"/>
                              </b-col>
                              <b-col cols="6" md="3" class="pr-1 mb-1">
                                <TextComponent 
                                  :form="persona.detallePregunta24" 
                                  name="nPartos" 
                                  label="N° Partos"
                                  type="number"        
                                  step="1"                                   
                                  :rules="`required|min_value:0|max_value:${persona.detallePregunta24.nEmbarazos||0}`"/>
                              </b-col>
                              <b-col cols="6" md="3" class="pr-1 mb-1">
                                <TextComponent 
                                  :form="persona" 
                                  name="detallePregunta24.nAbortos" 
                                  label="N° Abortos"
                                  type="number"        
                                  step="1"                                   
                                  rules="required|min_value:0|max_value:20"/>
                              </b-col>
                              <b-col cols="6" md="3" class="pr-1 mb-1">
                                <TextComponent 
                                  :form="persona" 
                                  name="detallePregunta24.nCesareas" 
                                  label="N° Cesáreas"
                                  type="number"        
                                  step="1"                                   
                                  :rules="`required|min_value:0|max_value:${persona.detallePregunta24.nPartos||0}`"/>
                              </b-col>
                            </b-row>
                          </template>
                          <b-form-radio-group
                            v-else
                            v-model="persona.respuestas[indexPregunta]"
                            :options="control.TIPOS_SINO"
                            buttons
                            button-variant="outline-primary"
                            size="sm"
                            class="cuestionario-sino"
                            :name="'p-' + indexPersona + '-' + indexPregunta"
                          />
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>

            <b-alert v-if="personasConDatos.length === 0" show variant="info">
              No hay personas con datos cargados. Complete el paso anterior
               (Relación de personas a asegurar).
            </b-alert>

            <b-row v-else align-h="end" class="mt-4">
              <b-col md="4" cols="4" style="display: flex; justify-content: flex-end">
                <b-button @click="previous" variant="secondary">Anterior</b-button>
                <b-button type="submit" variant="primary">Siguiente</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </validation-observer>

      
    </b-container>
  </div>
</template>

<script>
import DateComponent from "@/components/controls/DateComponent.vue";
import TextComponent from "@/components/controls/TextComponent.vue";
import { PREGUNTAS_CUESTIONARIO_MEDICO, TIPOS_SINO } from "@/data/colombia/salud/Selects";

const CANTIDAD_PREGUNTAS = PREGUNTAS_CUESTIONARIO_MEDICO.length;
const CANTIDAD_FILAS_DEFAULT = 6;

function personaVacia() {
  return {
    name: "",
    document: "",
    birthDay: "",
    relation: "",
    weight: "",
    stature: "",
    sex: "",
    eps: "",
  };
}

function personaTieneDatos(p) {
  if (!p) return false;
  return !!(
    (p.name && String(p.name).trim()) ||
    (p.document && String(p.document).trim()) ||
    p.birthDay ||
    p.relation ||
    (p.weight !== undefined && p.weight !== null && p.weight !== "") ||
    (p.stature !== undefined && p.stature !== null && p.stature !== "") ||
    p.sex ||
    (p.eps && String(p.eps).trim())
  );
}

export default {
  name: "FormColombiaSalud03",
  components: { DateComponent, TextComponent },
  data() {
    return {
      control: { TIPOS_SINO },
      PREGUNTAS_CUESTIONARIO_MEDICO,
      personasAbiertas: [],
    };
  },
  computed: {
    form() {
      return this.$store.state.wizard.form || {};
    },
    personasConDatos() {
      const list = this.form.beneficiarios;
      if (!list || !Array.isArray(list)) return [];
      return list.filter(personaTieneDatos);
    },
  },
  created() {
    const form = this.$store.state.wizard.form;
    if (!form || form === null) return;
    if (!form.beneficiarios || !Array.isArray(form.beneficiarios)) {
      this.$set(form, "beneficiarios", []);
    }
    while (form.beneficiarios.length < CANTIDAD_FILAS_DEFAULT) {
      form.beneficiarios.push(personaVacia());
    }
    if (form.beneficiarios.length > CANTIDAD_FILAS_DEFAULT) {
      form.beneficiarios = form.beneficiarios.slice(0, CANTIDAD_FILAS_DEFAULT);
    }
    form.beneficiarios.forEach((persona) => {
      if (!personaTieneDatos(persona)) return;
      if (!persona.respuestas || persona.respuestas.length !== CANTIDAD_PREGUNTAS) {
        this.$set(persona, "respuestas", Array(CANTIDAD_PREGUNTAS).fill(""));
      }
      if (persona.sex === "F") {
        if (persona.fechaPregunta22 === undefined) this.$set(persona, "fechaPregunta22", "");
        if (!persona.detallePregunta24 || typeof persona.detallePregunta24 !== "object") {
          this.$set(persona, "detallePregunta24", {
            nEmbarazos: "",
            nPartos: "",
            nAbortos: "",
            nCesareas: "",
          });
        } else {
          const d = persona.detallePregunta24;
          if (d.nEmbarazos === undefined) this.$set(d, "nEmbarazos", "");
          if (d.nPartos === undefined) this.$set(d, "nPartos", "");
          if (d.nAbortos === undefined) this.$set(d, "nAbortos", "");
          if (d.nCesareas === undefined) this.$set(d, "nCesareas", "");
        }
      }
    });
    const conDatos = form.beneficiarios.filter(personaTieneDatos);
    this.personasAbiertas = conDatos.map((_, i) => i === 0);
  },
  mounted() {
    this.$store.dispatch("app/loading", true);
    const form = this.$store.state.wizard.form;
    if (form === undefined || form === null) {
      this.$router.push("/form/colombia/salud/");
      this.$store.dispatch("app/loading", false);
      return;
    }
    (form.beneficiarios || []).forEach((persona) => {
      if (persona.sex === "F" && personaTieneDatos(persona)) {
        if (persona.fechaPregunta22 === undefined) this.$set(persona, "fechaPregunta22", "");
        if (!persona.detallePregunta24 || typeof persona.detallePregunta24 !== "object") {
          this.$set(persona, "detallePregunta24", {
            nEmbarazos: "",
            nPartos: "",
            nAbortos: "",
            nCesareas: "",
          });
        }
      }
    });
    this.$store.dispatch("app/loading", false);
  },
  methods: {
    preguntasCount(persona) {
      return persona.sex === "F" ? 22 : 21;
    },
    contestadasCount(persona) {
      const r = persona.respuestas || [];
      if (persona.sex === "F") {
        let count = 0;
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22].forEach((i) => {
          if (i < r.length && (r[i] === "S" || r[i] === "N")) count++;
        });
        if (persona.fechaPregunta22 && String(persona.fechaPregunta22).trim()) count++;
        const d = persona.detallePregunta24;
        if (d && (d.nEmbarazos !== "" || d.nPartos !== "" || d.nAbortos !== "" || d.nCesareas !== "")) count += 1;
        return count;
      }
      const max = 21;
      let count = 0;
      for (let i = 0; i < max && i < r.length; i++) {
        if (r[i] === "S" || r[i] === "N") count++;
      }
      return count;
    },
    togglePersona(index) {
      this.$set(this.personasAbiertas, index, !this.personasAbiertas[index]);
    },
    marcarTodoNo(persona) {
      const r = persona.respuestas || [];
      const indices = persona.sex === "F" ?
       [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22] :
       [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
      indices.forEach((i) => this.$set(r, i, "N"));
    },
    limpiarSeccionesPersona(persona) {
      const n = PREGUNTAS_CUESTIONARIO_MEDICO.length;
      this.$set(persona, "respuestas", Array(n).fill(""));
      if (persona.sex === "F") {
        this.$set(persona, "fechaPregunta22", "");
        this.$set(persona, "detallePregunta24", {
          nEmbarazos: "",
          nPartos: "",
          nAbortos: "",
          nCesareas: "",
        });
      }
    },
    previous() {
      this.$store
        .dispatch("wizard/save", { index: 2, form: this.form })
        .then(() => this.$router.push("/form/colombia-salud-2.html"));
    },
    next() {
      const incompletos = this.personasConDatos.some((p) => {
        const r = p.respuestas || [];
        if (p.sex === "F") {
          const indicesSino = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21];
          if (r.length < 22) return true;
          return indicesSino.some((i) => r[i] !== "S" && r[i] !== "N");
        }
        const max = 21;
        if (r.length < max) return true;
        for (let i = 0; i < max; i++) {
          if (r[i] !== "S" && r[i] !== "N") return true;
        }
        return false;
      });
      if (incompletos) {
        this.$bvToast.toast("Debe responder Sí o No a todas las preguntas de cada persona.", {
          title: "Validación",
          variant: "warning",
          solid: true,
        });
        return;
      }
      this.$store
        .dispatch("wizard/save", { index: 3, form: this.form })
        .then(() => this.$router.push("/form/colombia-salud-4.html"));
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1600px;
}
.cuestionario-pregunta {
  margin-bottom: 0.5rem;
}
.cuestionario-row {
  min-height: 2.25rem;
}
/* Colores primario y secundario del proyecto */
.cuestionario-persona-header {
  cursor: pointer;
  background-color: rgba(0, 39, 118, 0.08) !important;
  border-left: 3px solid var(--one);
}
.cuestionario-persona-header:hover {
  background-color: rgba(0, 39, 118, 0.12) !important;
}
.cuestionario-persona-nombre {
  color: var(--one) !important;
}
.cuestionario-persona-chevron {
  color: var(--two) !important;
}
.cuestionario-contadas {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--four);
}
.cuestionario-sino >>> .btn-outline-primary {
  color: var(--secondary) !important;
  border-color: var(--secondary) !important;
}

/* Cambiar color de hover a azul */
.cuestionario-sino >>> .btn-outline-primary:hover {
  background-color: var(--secondary) !important;
  border-color: var(--secondary) !important;
  color: #fff !important;
}

/* Cambiar color de hover a dorado */
.cuestionario-sino >>> .btn-outline-primary:first-child:hover {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
  color: #fff !important;
}

/* Cambiar color de active a azul */
.cuestionario-sino >>> .btn-outline-primary.active,
.cuestionario-sino >>> .btn-check:checked + .btn-outline-primary {
  background-color: var(--secondary) !important;
  border-color: var(--secondary) !important;
  color: #fff !important;
}

/* Cambiar color de active a dorado */
.cuestionario-sino >>> .btn-outline-primary:first-child.active,
.cuestionario-sino >>> .btn-outline-primary:first-child.btn-active {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
  color: #fff !important;
}
</style>
